Reflux = require 'reflux'

module.exports = Reflux.createActions ['ageVerification', 'reset']



/** WEBPACK FOOTER **
 ** ./src/scripts/actions/age-verification.coffee
 **/